module.exports = __webpack_public_path__ + "static/img/oppo3.a8346e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/oppo/oppo3.png
// module id = n+Gw
// module chunks = 0